module.exports = __webpack_public_path__ + "static/media/rppr4.bb54165b.png";